import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/twitter.svg'
import _imports_1 from '@/assets/logo-opensea.svg'
import _imports_2 from '@/assets/logo-nifty.svg'
import _imports_3 from '@/assets/logo-foundation.svg'
import _imports_4 from '@/assets/logo-sr.svg'


const _withScopeId = n => (_pushScopeId("data-v-313ebffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "m-wallet-identity-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = { class: "m-wallet-identity-twitter-handle" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-wallet-identity-marketplace-logo",
  src: _imports_1
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OpenSea", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-wallet-identity-marketplace-logo",
  src: _imports_2
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nifty Gateway", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-wallet-identity-marketplace-logo",
  src: _imports_3
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Foundation", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = ["href"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-wallet-identity-marketplace-logo",
  src: _imports_4
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "SuperRare", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import {
  ChevronDownIcon
} from '@heroicons/vue/20/solid';
import { computed, onMounted, Ref, ref } from 'vue';
import BoredAvatar from 'vue-boring-avatars';
import '@/assets/tailwind.css';
import BadgesAPIClient from '@/api/badges/badges';
// @ts-ignore
import SkeletonLoader from '@/components/SkeletonLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MWalletIdentity',
  props: ['wallet', 'darkMode'],
  setup(__props) {

const props = __props


// eslint-disable-next-line
const badges:Ref<any> = ref({});

// Get the prop values
const wallet = computed(() => {
  return props.wallet;
});

const darkMode = computed(() => {
  return !!props.darkMode;
});

onMounted(async () => {
  badges.value = await BadgesAPIClient.getBadges(wallet.value);
});

const formatAddress = (address: string) : string => {
  address = address.toLowerCase();
  if (address.indexOf('0x') >= 0) {
    return `${address.slice(0, 5)}...${address.slice(-3)}`;
  } else {
    return `0x${address.slice(0, 3)}...${address.slice(-3)}`;
  }
};

return (_ctx: any,_cache: any) => {
  return (!badges.value.opensea)
    ? (_openBlock(), _createBlock(SkeletonLoader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (badges.value.ensAvatar)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "m-wallet-identity-avatar",
              src: badges.value.ensAvatar,
              width: "32",
              height: "32",
              style: {"background-color":"lightgray","border-radius":"9999px"}
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createBlock(_unref(BoredAvatar), {
              key: 1,
              class: "m-wallet-identity-avatar",
              name: _unref(wallet)
            }, null, 8, ["name"])),
        (badges.value && badges.value.twitter)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              class: "m-wallet-identity-twitter-link",
              href: `https://twitter.com/${badges.value.twitter}`,
              target: "blank"
            }, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, " @" + _toDisplayString(badges.value.twitter), 1)
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (badges.value && badges.value.ens)
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: _normalizeClass(["m-wallet-identity-title", _unref(darkMode) ?? 'm-wallet-identity-title-dark']),
              href: `https://etherscan.io/address/${_unref(wallet)}`,
              target: "blank"
            }, _toDisplayString(badges.value.ens), 11, _hoisted_6))
          : (_openBlock(), _createElementBlock("a", {
              key: 4,
              class: _normalizeClass(["m-wallet-identity-title", _unref(darkMode) ?? 'm-wallet-identity-title-dark']),
              href: `https://etherscan.io/address/${_unref(wallet)}`,
              target: "blank"
            }, _toDisplayString(formatAddress(_unref(wallet))), 11, _hoisted_7)),
        (badges.value)
          ? (_openBlock(), _createBlock(_unref(Menu), {
              key: 5,
              as: "div",
              class: "m-wallet-identity-menu"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(MenuButton), { class: "badges-menu-button" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronDownIcon), {
                      class: "h-2 w-2 p-0",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, {
                  "enter-active-class": "transition ease-out duration-100",
                  "enter-from-class": "transform opacity-0 scale-95",
                  "enter-to-class": "transform opacity-100 scale-100",
                  "leave-active-class": "transition ease-in duration-75",
                  "leave-from-class": "transform opacity-100 scale-100",
                  "leave-to-class": "transform opacity-0 scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MenuItems), { class: "badges-menu-popup" }, {
                      default: _withCtx(() => [
                        (badges.value.opensea)
                          ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 0 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "m-wallet-identity-marketplace",
                                  href: badges.value.opensea,
                                  target: "blank"
                                }, _hoisted_11, 8, _hoisted_8)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (badges.value.niftyGateway)
                          ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 1 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "m-wallet-identity-marketplace",
                                  href: badges.value.niftyGateway,
                                  target: "blank"
                                }, _hoisted_15, 8, _hoisted_12)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (badges.value.foundation)
                          ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 2 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "m-wallet-identity-marketplace",
                                  href: badges.value.foundation,
                                  target: "blank"
                                }, _hoisted_19, 8, _hoisted_16)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (badges.value.superRare)
                          ? (_openBlock(), _createBlock(_unref(MenuItem), { key: 3 }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  class: "m-wallet-identity-marketplace",
                                  href: badges.value.superRare,
                                  target: "blank"
                                }, _hoisted_23, 8, _hoisted_20)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
}
}

})